module.exports = __webpack_public_path__ + "assets/img/marriage-little-bg3.bef65903.png";